var map = {
	"./cricket_summaryLive.json": 769,
	"./cricket_summaryLive2.json": 770
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 768;



//////////////////
// WEBPACK FOOTER
// ../mock-data ^\.\/.*$
// module id = 768
// module chunks = 0